import React from 'react';
import moment from 'moment';
import UI from '../../commons/services/UI';
import { isPremium } from '../../commons/services/Wix';
import {
  wixWeekdays,
  wixLanguages,
  wixTimeFormats,
  wixDateFormats
} from '../../commons/services/static';
import createNavigationContainer
  from '../../commons/components/createNavigationContainer';
import { params } from '../../commons/services/styles';
import { badgesById, getNormalizedBadgeId } from '../../commons/badges';

const TIMEZONES = moment.tz
  .names()
  .map((val, i) => ({ value: '' + i, label: val }));

function PremiumTeaser({ onUpgradeClick }) {
  return (
    <div>
      <div className="PremiumTeaserContainer" style={{ marginBottom: 0 }}>
        <div className="PremiumTeaserUpgradeSymbol">
          <UI.symbol name="premiumLarge" onClick={onUpgradeClick} />
        </div>
        Please upgrade to premium in order to show your business hours in a table when a user clicks the sign.
      </div>
      <UI.toggleSwitch
        label="Show business hours"
        defaultValue={true}
        disabled
      />
    </div>
  );
}

function BadgeSettings({ data }) {
  const selectedBadge = getNormalizedBadgeId(data.selectedBadge);
  const badgeIsAnimated = badgesById[selectedBadge].animated;
  const supportsNoSubline = badgesById[selectedBadge].supportsNoSubline;

  return (
    <div>
      <hr className="divider-long" />
      <UI.sectionDividerLabeled label="Sign Settings" />
      <hr className="divider-long" />

      {badgeIsAnimated
        ? <UI.toggleSwitch
            label="Animate Sign"
            infoText="Choose if you want your sign to be animated."
            defaultValue={true}
            wix-param={params.animateEnabled}
          />
        : null}

      {supportsNoSubline
        ? <UI.toggleSwitch
            label={'Disable Subline'}
            infoText="Select if you want the sign to only display 'Open' or 'Closed' without further information."
            defaultValue={false}
            wix-param={params.noSublineEnabled}
          />
        : null}

      {badgeIsAnimated || supportsNoSubline
        ? <hr className="divider-long" />
        : null}

      <UI.dropDownSelect
        defaultValue={`${moment.tz.names().indexOf(moment.tz.guess())}`}
        title="Time Zone"
        options={TIMEZONES}
        wix-param={params.timezone}
      />

      <hr className="divider-long" />

      <UI.dropDownSelect
        title="Language (beta)"
        options={wixLanguages}
        wix-param={params.language}
      />

      <UI.dropDownSelect
        title="First day of the week"
        options={wixWeekdays}
        wix-param={params.firstDayOfWeek}
      />

      <UI.dropDownSelect
        title="Time format"
        options={wixTimeFormats}
        wix-param={params.timeFormat}
      />

      <UI.dropDownSelect
        title="Date format"
        options={wixDateFormats}
        wix-param={params.dateFormat}
      />
    </div>
  );
}

function ModalSettings({ onUpgradeClick }) {
  const toggleSwitch = (
    <UI.toggleSwitch
      label="Show business hours"
      infoText="If a visitor clicks on your sign it will show your business hours in a table."
      defaultValue={true}
      wix-param={params.modalEnabled}
    />
  );

  return (
    <div>
      <hr className="divider-long" />
      <UI.sectionDividerLabeled label="Table Settings" />
      <hr className="divider-long" />
      {isPremium()
        ? toggleSwitch
        : <PremiumTeaser onUpgradeClick={onUpgradeClick} />}
    </div>
  );
}

function SettingsTab({ data, onUpgradeClick }) {
  return (
    <div>
      <BadgeSettings data={data} />
      <ModalSettings onUpgradeClick={onUpgradeClick} />
      <div style={{ height: '200px' }} />
    </div>
  );
}

export default createNavigationContainer(SettingsTab);



// WEBPACK FOOTER //
// ./src/apps/settings/SettingsTab.jsx